module.exports = __webpack_public_path__ + "media/icons/linkedin-17371022.png";